class SearchDrawer extends DrawerElement {
    constructor() {
        super()
    }
    get shouldAppendToBody() {
        return !1
    }
    get input() {
        return this.querySelector('input[type="search"]')
    }
    get focusElement() {
        return this.querySelector('input[type="search"]')
    }
}
customElements.define("search-drawer", SearchDrawer);
class SearchTyped extends HTMLElement {
    constructor() {
        super(), Motion.inView(this, this.init.bind(this))
    }
    get startDelay() {
        return parseFloat(this.dataset.delay || 0)
    }
    async init() {
        this.insertCursor(), await this.start(this.dataset.firstText, this.startDelay), setTimeout((async () => {
            await this.reset(), await this.start(this.dataset.lastText, 0)
        }), 600)
    }
    async start(e, t) {
        this.innerHTML = e, await Motion.animate(this, {
            width: [0, `${this.scrollWidth}px`]
        }, {
            duration: 1,
            delay: t
        }).finished, this.cursor.classList.add("blink")
    }
    async reset() {
        this.cursor.classList.remove("blink"), await Motion.animate(this, {
            width: 0
        }, {
            duration: .25
        }).finished
    }
    insertCursor() {
        this.cursor || (this.cursor = document.createElement("span"), this.cursor.className = "typed-cursor", this.cursor.setAttribute("aria-hidden", !0), this.cursor.innerHTML = "|", this.parentElement.insertBefore(this.cursor, this.nextSibling))
    }
}
customElements.define("search-typed", SearchTyped);
class PredictiveSearch extends HTMLFormElement {
    constructor() {
        super(), this.cachedMap = new Map, this.focusElement = this.input, this.resetButton.addEventListener("click", this.clear.bind(this)), this.input.addEventListener("click", this.hideTypewriter.bind(this)), this.input.addEventListener("input", theme.utils.debounce(this.onChange.bind(this), 300)), this.input.addEventListener("focus", this.onFocus.bind(this))
    }
    get input() {
        return this.querySelector('input[type="search"]')
    }
    get resetButton() {
        return this.querySelector('button[type="reset"]')
    }
    get typewriter() {
        return this.input.previousElementSibling
    }
    hideTypewriter() {
        this.typewriter && !this.typewriter.hasAttribute("hidden") && this.typewriter.setAttribute("hidden", "")
    }
    onFocus(e) {
        document.body.classList.add("predictive-search-open");
        if (0 === this.getQuery().length) return;
        const t = this.buildUrl().toString();
        this.renderSection(t, e)
    }
    clear(e = null) {
        e && e.preventDefault(), this.input.value = "", this.input.focus(), this.removeAttribute("results")
    }
    getQuery() {
        return this.input.value.trim()
    }
    buildUrl() {
        const baseOrigin = window.location.origin;
        const e = new URL(`${baseOrigin}${theme.routes.predictive_search_url}`);
        return e.searchParams.set("q", this.getQuery()), e.searchParams.set("resources[limit]", this.dataset.limit || 3), e.searchParams.set("resources[limit_scope]", "each"), e.searchParams.set("section_id", theme.utils.sectionId(this)), e
    }
    onChange() {
        if (0 === this.getQuery().length) return void this.clear();
        this.hideTypewriter();
        const e = this.buildUrl().toString();
        this.renderSection(e)
    }
    renderSection(e) {
        this.cachedMap.has(e) ? this.renderSectionFromCache(e) : this.renderSectionFromFetch(e)
    }
    renderSectionFromCache(e) {
        const t = this.cachedMap.get(e);
        this.renderSearchResults(t), this.setAttribute("results", "")
    }
    renderSectionFromFetch(e) {
        this.setAttribute("loading", ""), fetch(e).then((e => e.text())).then((t => {
            this.renderSearchResults(t), this.cachedMap.set(e, t), this.removeAttribute("loading"), this.setAttribute("results", "")
        }))
    }
    renderSearchResults(e) {
        const t = this.querySelector('[id^="PredictiveSearchResults-"]');
        if (t) {
            t.innerHTML = (new DOMParser).parseFromString(e, "text/html").getElementById(t.id).innerHTML;
        }
    }
}
customElements.define("predictive-search", PredictiveSearch, {
    extends: "form"
});
class PredictiveSearchOverlay extends OverlayElement {
    constructor() {
        super(), this.addEventListener("click", this.onClick)
    }
    onClick() {
        setTimeout((() => {
            document.body.classList.remove("predictive-search-open")
        }))
    }
}
customElements.define("predictive-search-overlay", PredictiveSearchOverlay);